import React from 'react';
import { Translation } from 'react-i18next';
import { Typography } from 'antd';
import Logger from '../../../../../lib/Logger';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';
import imageLoading from './../../../assets/images/image-loading.png';
import { StateCardTag } from '../../../elements/components/Tags';

const { Paragraph, Title } = Typography;

const LearningAdminModuleCardLarge = ({
  item,
  getSignedUrl,
  imageUrl,
  setActiveImage,
  imagePath,
  history,
  ...props
}) => {
  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  return (
    <Translation>
      {(t) => (
        <>
          <div className='learning-module-card' key={item.id}>
            <div className='learning-module-card-image-container'>
              <img
                className='cursor-pointer'
                alt='media-module'
                src={imageUrl ?? imageLoading}
              />
            </div>
            <div className='learning-module-card-content'>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Title
                  level={5}
                  style={{ margin: 0 }}
                  className='cursor-pointer'
                >
                  {item.title}
                </Title>
                <StateCardTag value={0} />
              </div>

              <Paragraph ellipsis={{ rows: 2 }}>{item.description}</Paragraph>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Link
                  to='#'
                  style={{ textDecoration: 'underline' }}
                  onClick={(e) => e.preventDefault()}
                >
                  {t('learning_module_continue_module')}
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleCardLarge);

Logger.log('silly', `LearningAdminModuleCardLarge loaded.`);
